import { useCallback } from 'react'
import {
  ToggleDoubleProvDiv,
  ToggleFieldVisible,
  ToggleFixedFlucs,
  ToggleMarketMovers,
  ToggleQuaddieProvDiv,
  ToggleRaceReplayVisible,
  ToggleResultsVisible,
  ToggleShowAllForm,
  ToggleStewardsCommentsVisible,
  ToggleTipsVisible,
} from '@core/Areas/RaceCard/Components/RaceCardContent/Components/LegacyKnockout/ViewModels/Betting-v2/Components/Commands/driver'
import type { Button, ToggleButton } from '../Types'
import { useCommandState } from './useCommandState'

type UseBetInformers = {
  buttons: Record<Button, boolean>
  toggleButton: ToggleButton
}

const actions: Record<Button, () => void> = {
  showDoubleProvDiv: ToggleDoubleProvDiv,
  showFixedFlucs: ToggleFixedFlucs,
  showAllForm: ToggleShowAllForm,
  showMarketMovers: ToggleMarketMovers,
  showQuaddieProvDiv: ToggleQuaddieProvDiv,
  commentsVisible: ToggleStewardsCommentsVisible,
  tipsVisible: ToggleTipsVisible,
  resultsVisible: ToggleResultsVisible,
  fieldVisible: ToggleFieldVisible,
  replayVisible: ToggleRaceReplayVisible,
}

export function useBetInformers(): UseBetInformers {
  const toggleButton = useCallback((button: Button): void => {
    actions[button as Button]()
  }, [])

  const commandState = useCommandState()

  return {
    buttons: commandState,
    toggleButton,
  }
}
